<!-- No max-height/overflow/side padding here: mat-bottom-sheet-container already caps at 80vh,
     scrolls, and pads 8px 16px. A second scroller inside it showed two scrollbars on Windows. -->
<div class="pb-6">

  <!-- Sticky so close stays reachable on long content. Sticky offsets from the container's
       content box, so -top-2/-mt-2 cover its 8px top padding instead of letting
       content show through above the header. -->
  <div class="sticky -top-2 z-10 -mt-2 pt-4 bg-white">
    <div class="flex justify-center pb-1">
      <div class="w-10 h-1 rounded-full bg-gray-300"></div>
    </div>

    <div class="flex items-center justify-between -mt-1 -mb-1">
      <h2 class="text-lg font-bold">Bookmarked messages</h2>
      <button type="button" mat-icon-button aria-label="Close" (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div *ngIf="isLoading" class="flex justify-center py-8">
    <mat-spinner diameter="28"></mat-spinner>
  </div>

  <ng-container *ngIf="!isLoading">
    <p *ngIf="!bookmarkedMessages.length" class="text-sm text-gray-500 py-6 text-center">
      No bookmarked messages yet.
    </p>

    <div
      *ngFor="let chat of bookmarkedMessages"
      class="flex items-start justify-between gap-2 py-3 border-b border-gray-100 cursor-pointer"
      (click)="goToChat(chat)"
    >
      <div class="min-w-0">
        <div class="text-sm font-bold">
          {{ chat.FromCorpMember | displayName }}
        </div>
        <div class="text-sm text-gray-700 truncate">{{ snippet(chat.message) }}</div>
        <div class="text-xs text-gray-400">{{ chat.created_at | date : 'd/M/yy, h:mm a' }}</div>
      </div>
      <button
        type="button"
        mat-icon-button
        aria-label="Remove bookmark"
        (click)="removeBookmark(chat, $event)"
      >
        <mat-icon>bookmark_remove</mat-icon>
      </button>
    </div>
  </ng-container>

</div>
